export const ErrorCode = {
  NO_LOGIN_OR_NO_DATA_RIGHT: -2,
};
